export const formatTimestamp = (dateString: string | null | undefined) => {
  if (!dateString) return "";
  const d = new Date(dateString);

  // Check if it's a valid date
  if (isNaN(d.getTime())) return dateString;

  const pad = (num: number) => num.toString().padStart(2, "0");

  const year = d.getFullYear();
  const month = pad(d.getMonth() + 1);
  const day = pad(d.getDate());
  const hours = pad(d.getHours());
  const minutes = pad(d.getMinutes());
  const seconds = pad(d.getSeconds());

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
